module.exports = __webpack_public_path__ + "static/rad-logo-shop-4beb7801caadb4356f0e9bdc86c130ce.svg";